export default '/build/6d4be4df.svg'